import React from 'react';
import style from './style.css';

const ShowValue = props => {
    const { colors, data } = props;
    return (
        <div className={style.wrapper} style={colors ? { color: colors.primary } : {}}>
            {data}
        </div>
    );
};

export default ShowValue;
